import { CarouselFeature } from "./feature-base.js";
class ChildFocusFeature extends CarouselFeature {
  constructor() {
    super(...arguments);
    this.pointerInteraction = false;
    this.registerPointerEvent = () => {
      this.pointerInteraction = true;
      this.micro(() => {
        this.pointerInteraction = false;
      }, "registering user pointer events");
    };
    // Safari does not focus a clicked button by design. https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#clicking_and_focus
    this.safariClickFocusPoly = (ev) => {
      const { assignedChildren } = this.host;
      const dispatcher = ev.composedPath().find(
        (elem) => assignedChildren.includes(elem)
      );
      if (dispatcher && !dispatcher.matches(":focus, :focus-within")) {
        this.pointerInteraction = true;
        dispatcher.focus();
      }
    };
    this.childFocusHandler = (ev) => {
      const {
        scrollContainer,
        assignedChildren,
        controls,
        features: { slideVisibility, scroller, writingDirection }
      } = this.host;
      const scrollLeftBeforeFocus = scrollContainer.scrollLeft;
      const dispatcher = ev.composedPath().find(
        (elem) => assignedChildren.includes(elem)
      );
      if (dispatcher) {
        slideVisibility.updateVisibleSlides(scrollContainer.scrollLeft);
        let focusDirection = 0;
        if (ev.relatedTarget) {
          if (ev.relatedTarget.getBoundingClientRect().x > dispatcher.getBoundingClientRect().x)
            focusDirection = -1;
        }
        const wasPointerInteraction = this.pointerInteraction;
        this.pointerInteraction = false;
        this.micro(() => {
          scrollContainer.scrollLeft = scrollLeftBeforeFocus;
          if (slideVisibility.slidesVisibilityRatio[assignedChildren.indexOf(dispatcher)] === 1) {
            if (wasPointerInteraction)
              return;
            const rtlSign = writingDirection.isRTL ? -1 : 1;
            const nextFocusItemIndex = assignedChildren.indexOf(dispatcher) + (focusDirection || 1) * rtlSign;
            const nextFocusItem = assignedChildren[nextFocusItemIndex];
            if (!(nextFocusItem && slideVisibility.slidesVisibilityRatio[nextFocusItemIndex] !== 1))
              return;
          }
          scroller.scroller.inertia = 0;
          this.host.scrollToSlide(
            dispatcher,
            !focusDirection ? 0 : 1,
            controls.controllerWidth
          );
        }, "carousel child focus handler");
      }
    };
  }
  connectedCallback() {
    this.host.addEventListener("focus", this.childFocusHandler, {
      capture: true,
      passive: true
    });
    this.host.slides.addEventListener("click", this.safariClickFocusPoly, {
      capture: true,
      passive: true
    });
    this.host.slides.addEventListener("mousedown", this.registerPointerEvent);
  }
  disconnectedCallback() {
    this.host.removeEventListener("focus", this.childFocusHandler, {
      capture: true
    });
    this.host.slides.removeEventListener("click", this.safariClickFocusPoly, {
      capture: true
    });
    this.host.slides.removeEventListener(
      "mousedown",
      this.registerPointerEvent
    );
  }
}
export {
  ChildFocusFeature
};
